module.exports = __webpack_public_path__ + "img/funvilla.b73b025c.png";